import { createSlice } from '@reduxjs/toolkit';

const gradesSlice = createSlice({
  name: 'grades',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    fetchGradesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchGradesSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    fetchGradesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchGradesStart, fetchGradesSuccess, fetchGradesFailure } = gradesSlice.actions;
export default gradesSlice.reducer;
